// extracted by mini-css-extract-plugin
module.exports = {"base":"title_base__CtRgo","h1":"title_h1__l2cCM","h2":"title_h2__WlU3H","h3":"title_h3__gdHtb","h4":"title_h4__r0Pwq","h5":"title_h5__8P6CA","border":"title_border__Nbaop"};